/* ==========================================================================
   Bareboat Yacht Club — non-navigating parent menu items

   Shopify requires every navigation item to carry a URL, so "Shop" and
   "Collections" cannot be made link-less in the navigation editor. This
   intercepts the click instead.

   Scope: any top-level link that Horizon wraps in .menu-list__trigger — that
   wrapper is only rendered for items that have children, so leaf items like
   The Logbook and Articles are untouched.

   Accessibility: Horizon renders a separate .menu-list__disclosure button beside
   each parent link, hidden until :focus-visible. Keyboard users open submenus
   with that button, not the link, so blocking the link costs them nothing.

   Mobile: the drawer is rendered by a different template and does not use
   .menu-list__trigger, so it is unaffected by this file.
   ========================================================================== */

(function () {
  'use strict';

  function handle(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest('#header-component .menu-list__trigger > a');
    if (!link) return;

    event.preventDefault();
    event.stopPropagation();
  }

  document.addEventListener('click', handle, true);

  /* Enter and Space on the link itself would also navigate. The disclosure
     button remains fully operable. */
  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      handle(event);
    },
    true
  );
})();
